import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import * as Sentry from '@sentry/react';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

function useCheckAvatarExistence(url) {
    const [isAvailable, setAvailable] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!!url && url.length) {
                    const resp = await fetch(url, { method: 'GET' });
                    setAvailable(resp.status === 200);
                }
            } catch (e) {
                Sentry.captureException(e, {
                    level: 'log',
                });
                setAvailable(false);
            }
        };

        fetchData();
    }, [url]);

    return isAvailable;
}

const renderRemoteAvatar = (url) => <DiskBadge src={url} alt="User" flagName="paysend" />;

const renderDefaultAvatar = (name) => {
    if (!!name && name.length > 0) {
        const firstLetter = name[0];
        return <DiskBadge diskText={firstLetter.toUpperCase()} flagName="paysend" />;
    }

    return null;
};

const Contact = ({ fullName, phoneNum, avatarUrl, ...props }) => {
    const isAvailable = useCheckAvatarExistence(avatarUrl);

    const renderAvatar = () => {
        return avatarUrl && isAvailable ? renderRemoteAvatar(avatarUrl) : renderDefaultAvatar(fullName);
    };

    return (
        <Panel type="button" onClick={props.onClick} negativeMargin isHoverable>
            <PanelFrame>
                <DiskBadgeWrapper>{renderAvatar()}</DiskBadgeWrapper>
                <PanelContent>
                    <PanelRow>{fullName}</PanelRow>
                    <PanelRow>
                        <Text size="secondary" color="secondary">
                            {phoneNum}
                        </Text>
                    </PanelRow>
                </PanelContent>
            </PanelFrame>
        </Panel>
    );
};

export const type = {
    fullName: PropTypes.string,
    avatarUrl: PropTypes.string,
    phoneNum: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

Contact.propTypes = type;

export default Contact;
